// Release the navigation column before normal page-header actions need icon-only labels.
export const SIDEBAR_COLLAPSE_BREAKPOINT = 1024
export const EXPANDED_SIDEBAR_WIDTH = 178

export const EXPANDED_SIDEBAR_WIDTH_CLASS = "w-[178px]"
